import { gql } from '@apollo/client'

export const GET_CROSS_SELLING_PRODUCTS_QUERY = gql`
  query getCrossSellingProducts($category: String, $sapId: String!, $warehouseIds: [String!]!) {
    getCrossSellingProducts(
      input: { category: $category, sapId: $sapId, warehouseIds: $warehouseIds }
    ) {
      categories {
        count
        name
      }
      products {
        id
        sapId
        labels {
          ... on Label {
            text
            type
          }
          ... on CustomLabel {
            text
            color
          }
        }
        priceDimension
        title
        dehaId
        oxomiId
        obetaId
        unit
        minimumAmount
        isSendable
        isTopseller
        isCutProduct
        isBlackListed
        isForSale
        type
        prices {
          listPrice
          catalogPrice
          metalNeAddition
          strikeThroughPrice
          netPrice
          currency
        }
        supplierImageData {
          large
        }
        imageData {
          images {
            large
          }
        }
        images {
          url
          width
        }
        stock(warehouseIds: $warehouseIds) {
          sapId
          warehouseId
          amount
          unit
        }
        stockAvailabilityEstimate {
          sapId
          minValue
          maxValue
          error
          unit
        }
      }
    }
  }
`
